import * as React from 'react';

import { RecordSVG } from '../../SVGS/RecordSVG';
import { ParentTabProps, Tab, TabProps } from './Tab';

export const RecorderTab = (props: ParentTabProps) => {
  const name = 'Recorder';
  const icon = <RecordSVG title={name} width="23.78" height="22.78" fill="#a0a0a0" />;
  const propsForTab: TabProps = {
    activeTab: props.activeTab,
    cssClass: 'tab--recorder',
    id: 'record',
    onClick: props.onSelect,
    name,
    icon,
  };
  return <Tab key={name} {...propsForTab} />;
};
